import template from './datasets-value-result.hbs'
import enums from 'scoreboard/components/enums'
import i18n from 'scoreboard/components/i18n'
import DatasetsResult from './datasets-result'
import _ from 'lodash'
import loadingDots from 'scoreboard/components/loading-dots.hbs'
import momentHelper from 'scoreboard/components/moment-helper'
import getAggregatedDataType from 'scoreboard/components/get-aggregated-data-type'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import DataType from 'scoreboard/datasets/model/data-type'
import formatHtmlValue from 'scoreboard/components/format-html-value'
const { DATE } = DataType

var DatasetsValueResult = DatasetsResult.extend({

	// this.options.table is the settings for displaying the results
	// this.options.field is field this result is based on
	// this.options.result is the result

	render: function () {
		this.renderHeader()
		this.updateHeaderLabel()
		this.renderRows()
		this.$('.loading-dots-container').append(loadingDots())
		if (!_.result(this.options.table, 'valid', true)) {
			this.$('.panel-content').addClass('is-not-displayed')
		}
		return this
	},

	// there's only one row, but this keeps the API consistent with
	// datasets-tabular-result
	renderRows: function() {
		this.$('.panel-content').remove()
		this.$el.append(template(this.context()))
		// If we're abbreviating numbers in our results, show nonAbbreviatedTooltips
		if (!this.options.suppressTooltips && _.get(this.options.table.attributes, 'abbreviateNumbers', true)) {
			this.setupNonAbbreviatedTooltips()
		}
		//#17238 need to ensure the correct things stay hidden when re-rendering
		this.secure()
	},

	getAggregationType: function() {
		// if someone has a numeric primary key, there is no aggregation type
		// specified on the field.  the server defaults to doing a sum, so
		// default to a sum here as well.
		return this.options.table.attributes.summaryType ||
			this.options.field.aggregationType || 'sum'
	},

	getAggregatedDataType: function() {
		const aggregationType = this.getAggregationType()
		const underlyingField = this.model.getUnderlyingField(this.options.field)
		const dataType = !_.isNil(underlyingField) ? underlyingField.dataType :
			this.options.field?.dataType
		return getAggregatedDataType(dataType, aggregationType)
	},

	context: function() {
		let aggregationType = this.getAggregationType()
		var aggregationKey = enums.aggregationType[aggregationType]
		if (this.options.field?.dataType === DATE) {
			aggregationKey += '.date'
		}
		let shorten = _.get(this.options.table.attributes, 'abbreviateNumbers', true)
		var result, unshortenedValue
		const dataType = this.getAggregatedDataType()
		var valueOptions = {
			value: this.options.result.result,
			dataType: dataType,
			precision: this.options.field?.precision,
			timeZone: this.options.field?.timeZone,
			timeFormat: momentHelper.getTimeFormat(this.options.field?.timeDisplayType),
			currencyCode: _.get(this.options.field, 'currencyCode')
		}

		// If we're not shortening results in the first place, we don't need
		// to worry about showing the non-abbreviated tooltip
		if (!shorten) {
			result = formatHtmlValue(_.extend({ shorten: false }, valueOptions))
		// If we are showing shortened results, check to see if that shortned
		// result actually was abbreviated and, if so, keep track of it's unshortened
		// version for the non-abbreviated tooltip
		} else {
			let shortened = formatHtmlValue(valueOptions)
			let unshortened = formatHtmlValue(_.extend({ shorten: false }, valueOptions))
			unshortenedValue = shortened != unshortened ? unshortened : null
			result = shortened
		}

		return {
			aggregation: i18n.get(aggregationKey),
			result: result,
			field: aggregationType,
			unshortenedValue: unshortenedValue,
			aggregationType,
		}
	},

	getDatasetSeriesOptions: function(e) {
		const options = DatasetsResult.prototype.getDatasetSeriesOptions.apply(this, arguments)
		_.extend(options, {
			columnFieldId: this.options.field?.id,
			columnVisibleLinkedFieldId: this.options.table.get('visibleLinkedFieldId'),
			columnAggregationType: this.options.table.get('summaryType')
		})
		return options
	},

	secure: function() {
		DatasetsResult.prototype.secure.apply(this, arguments)
		let resultDataType = this.getAggregatedDataType()
		// #33313 when not on the explore tab, allow drilldowns
		if (this.options.explore &&
			// #51310 can only create metrics based on numeric data
			!isNumericDataType(resultDataType)) {
			this.$('.value').removeClass('value text-link-emphasized')
		}
	}

})

export default DatasetsValueResult

DatasetsValueResult.__filename__ = 'datasets/overview/datasets-value-result.js'
